// @flow

import { observer } from "mobx-react";
import React from "react";
import UserStore from "app/stores/UserStore";
import FolderStore from "app/stores/FolderStore";
import Folder from "app/models/Folder";
import FolderList from "app/components/FolderList/FolderList";

type Props = {
    folders: any[],
};

@observer
export default class FolderListContainer extends React.Component<Props> {

    componentWillMount() {
        FolderStore.setFolders(Folder.makeArray(this.props.folders))
        FolderStore.select(FolderStore.folders[0]);
    }

    render() {
        return (
            <FolderList 
                user={UserStore.user}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/FolderListContainer.js